/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import Banners from '../../../stores/banners';
import Banner from '../../../stores/banner/banner';
import BannerUtil from './bannerUtil';
import LoggerUtil from '../../LoggerUtil';
import { LEFT_NAV_KEYS, APPS_COMPONENT_ID } from '../../enums';

const COMPONENT_ID = 'AllAppsBannerModelMapper';

class AllAppsBannerModelMapper {
    clearAllAppsBanners() {
        const filteredBanners = Banners.filterBanners({
            appSectionFilter: LEFT_NAV_KEYS.ALL_APPS_KEY,
        });
        filteredBanners.forEach((banner) => {
            Banners.removeBanner(banner);
        });
    }


    setAllAppsBanners(bannersJson, onAction, basePath, placeHolderMap,
        forceReplace = false, appData = {}, subSectionId) {
        Banners.setBannerLoaded('all');
        if (!bannersJson) {
            return null;
        }
        return BannerUtil.contentToBannerModel({
            bannersJson,
	        bannerAdder: (layoutId, bannerItemList, subSectionFilterKey) => {
                LoggerUtil.info(`${APPS_COMPONENT_ID}: ${COMPONENT_ID}: Adding banner for All Apps. Sub section: ${subSectionFilterKey}`);
                const currentBannerForSubsection = Banners.filterBanners({
                    appSectionFilter: LEFT_NAV_KEYS.ALL_APPS_KEY,
                    subSectionFilter: subSectionFilterKey,
                });
                if (!currentBannerForSubsection.length) {
                    Banners.addBanner((new Banner({
                        layoutId,
                        bannerItemList,
                        appSectionFilter: [LEFT_NAV_KEYS.ALL_APPS_KEY],
                        subSectionFilter: [subSectionFilterKey],
                    })));
                }

                if (forceReplace && currentBannerForSubsection.length) {
                    currentBannerForSubsection.forEach((banner) => {
                        Banners.removeBanner(banner);
                    });
                    Banners.addBanner((new Banner({
                        layoutId,
                        bannerItemList,
                        appSectionFilter: [LEFT_NAV_KEYS.ALL_APPS_KEY],
                        subSectionFilter: [subSectionFilterKey],
                    })));
                }
            },
            onAction,
            basePath,
            placeHolderMap,
            appData,
            subSectionId,
        });
    }
}

export default new AllAppsBannerModelMapper();
